import * as actionType from './WastemanagementAction';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import { Config } from '../config/config';
import Cookie from 'js-cookie';
import LZString from 'lz-string';

const config = JSON.parse(Config);
const apiInterface = config['api1'];

const initialState = {
    list:[],
    message: '',
    loading: false,
    apiStatus:false,
}
export const apiCallStatus = (data) => (dispatch) => {
    dispatch(apiStatus(data))
}
export const apiStatus = (data) => ({
    type: actionType.API_CALL_STATUS,
    payload: data,
})
export const GetWasteManagementData= (data) => ({
    type: actionType.Get_WASTEMANAGEMENT_DATA,
    payload: data,
})
export const GetWasteManagementList= (data) => ({
    type: actionType.Get_WASTEMANAGEMENT_LIST,
    payload: data,
})
export const _doGetWasteManagementData = () => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
      const data = {
        'fedid': user['userId'],
    }
    initialState.loading = true;
    ApiGateWay.SaveData(`${apiInterface}/WasteManagement/LoadWasteManagementInitialData`, data)
        .then((response) => {
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const CityList = response[3]?.Table4;
                const StoresList = response[4]?.Table5;
                const WasteManagementData = { CityList, StoresList }
                initialState.message = response[0]?.Table1[0]?.status_msg
                console.log(WasteManagementData, 'Waste Management Data')
                dispatch(GetWasteManagementData(WasteManagementData))
            }
        })
        .catch((e) => {
           console.log(e)
        })
}

export const _doGetWasteManagementList = (values) => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
       const data = {
        'startdate': values.fromdate,
        'enddate' : values.todate,
        'storeidlist': values.storeid.toString()
    }
    console.log(data);
    initialState.loading = true;
    ApiGateWay.SaveData(`${apiInterface}/WasteManagement/GenerateWasteManagementReport`, data)
        .then((response) => {
            if (response[0]?.Table1[0]?.status_code == '000') {
                const WasteManagementTable = response[1]?.Table2;
                const WasteManagementValues = response[2]?.Table3;
                const WasteManagementList = { WasteManagementTable , WasteManagementValues }
                initialState.message = response[0]?.Table1[0]?.status_msg
                console.log(WasteManagementList, 'Waste Management List')
                dispatch(GetWasteManagementList(WasteManagementList))
            }
        })
        .catch((e) => {
           console.log(e)
        })

}